import React from 'react';
import { Link } from 'react-router-dom';
import './Story.css';

function MissionBrief() {
  return (
    <>
      <section className="story" id="mission">
        <div className="story-inner">
          <span className="section-label reveal">Our Mission</span>
          <h2 className="section-title reveal">Biomedical Simulation, Built on Biology</h2>

          <div className="story-hook reveal">
            <p className="lead">
              Nexus Concordat is developing AI-driven simulation technologies designed
              to support biomedical research and drug development through advanced in
              silico modeling.
            </p>
            <p>
              Our mission is to accelerate scientific discovery by creating synthetic
              testing environments that allow researchers to explore hypotheses,
              generate synthetic datasets, and model biological responses before
              advancing to costly laboratory or clinical validation.
            </p>
            <p>
              <strong>We do not replace clinical trials, patients, or regulatory
              review.</strong> Instead, we aim to provide researchers with an additional
              decision-support layer that may help identify promising pathways, reduce
              development costs, and improve the efficiency of early-stage research.
            </p>
            <p>
              The technology requires extensive validation and real-world testing. Our
              current focus is building the scientific foundation, generating evidence,
              and establishing partnerships necessary to evaluate whether biologically
              grounded AI simulations can contribute meaningfully to future research and
              development workflows.
            </p>
            <p>
              We believe advances in artificial intelligence create an opportunity to
              model complex biological systems in ways that were previously impractical,
              enabling researchers to explore more possibilities while maintaining
              scientific rigor and regulatory compliance.
            </p>
          </div>
        </div>
      </section>

      <section className="story" id="first-product">
        <div className="story-inner">
          <span className="section-label reveal">Our First Product</span>
          <h2 className="section-title reveal">Where the Simulation Trains and the Simulation Sustains</h2>

          <div className="story-hook reveal">
            <p className="lead">
              Our initial commercial product is an interactive role-playing platform
              that generates structured behavioral simulation data.
            </p>
            <p>
              Players engage with persistent characters whose actions, decisions, and
              state transitions are recorded within a governed simulation environment.
              This creates a scalable source of synthetic behavioral data while
              simultaneously providing a consumer-facing product with independent
              commercial value.
            </p>
            <p>
              The simulation platform serves two functions. First, it operates as a
              standalone entertainment product. Second, it provides the data generation
              and testing environment used to develop, evaluate, and refine the broader
              simulation architecture.
            </p>
            <p>
              This approach allows the underlying technology to be trained and validated
              through real-world interaction while generating revenue independently of
              future research applications.
            </p>
            <p className="gold-text">
              Memory with metabolism. State with a curve. Trust with a half-life.
            </p>
            <p>
              We have modeled a full mathematical proof of how trust can be defined
              as a deviation from the established partnership distribution&mdash;explored
              in full on the{' '}
              <Link to="/philosophy" className="gold-text"><strong>Philosophy</strong></Link> page.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default MissionBrief;
